const deliveryManBillingsKeys = {
  module: ['deliveryManBillings'] as const,
  list: () => [...deliveryManBillingsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...deliveryManBillingsKeys.list(), filters] as const,
  details: (id: string) =>
    [...deliveryManBillingsKeys.module, 'details', id] as const,
};

export default deliveryManBillingsKeys;
